import { useState, type ReactNode } from 'react'

import { Chip } from '@/src/elements/chip/Chip'
import { Stack } from '@/src/elements/navigation/Stack'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'
import { useTranslate } from '@/src/lang/useTranslate'

import { SettingsScreenWrapper } from '../../components/SettingsScreenWrapper'
import { NotificationsCommunitiesList } from './NotificationsCommunitiesList'

export const NotificationsCommunitiesScreen = ({ searchParams }: TSearchParamsParam): ReactNode => {
  const [isSubscriptionAlive, setIsSubscriptionAlive] = useState(true)
  const { t } = useTranslate()
  const { updateParametersToken } = filterSearchParams<{ updateParametersToken: string }>(searchParams)

  return (
    <SettingsScreenWrapper testID={TEST_ID.SETTINGS.COMMUNITIES.SCREEN}>
      <Stack.Screen options={{ title: t('settings.notifications.incriptions.title') }} />
      <Chip
        iconName={isSubscriptionAlive ? undefined : ICON.CHECK}
        colors={isSubscriptionAlive ? 'default' : 'success'}
        variant="flat"
        text={t('words.see-all.plur-fem')}
        onPress={() => setIsSubscriptionAlive(!isSubscriptionAlive)}
        className="self-end"
      />
      <NotificationsCommunitiesList
        isSubscriptionAlive={isSubscriptionAlive}
        updateParametersToken={updateParametersToken}
      />
    </SettingsScreenWrapper>
  )
}
